import { useEffect, useState, useCallback } from 'react';
import { noop } from 'lodash';
import { ConsentGroup } from 'constants/consent';
import useIsConsentGroupEnabled from 'hooks/useIsConsentGroupEnabled';
import useAdRenderedCheck from '../useAdRenderedCheck';
import AdInfo from '../AdInfo';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const DirectAdvertisement = _ref => {
  let {
    id,
    config,
    onAdRender = noop
  } = _ref;
  const {
    0: adDivElement,
    1: setAdDivElement
  } = useState(null);
  const {
    0: isAdInfoVisible,
    1: setIsAdInfoVisible
  } = useState(false);
  const isConsentGroupEnabled = useIsConsentGroupEnabled(ConsentGroup.Targeting);
  const handleAdRender = useCallback(isAdVisible => {
    onAdRender(isAdVisible);
    setIsAdInfoVisible(isAdVisible);
  }, [onAdRender]);
  useAdRenderedCheck({
    targetElement: adDivElement,
    onAdRender: handleAdRender
  });
  useEffect(() => {
    if (!adDivElement || !window.dimatter) return;
    window.dimatter.push([config.code]);
    window.dimatter.push(['_requestBanners', config.code]);
  }, [adDivElement, config, isConsentGroupEnabled]);
  if (!isConsentGroupEnabled) return null;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [isAdInfoVisible && /*#__PURE__*/_jsx(AdInfo, {}), /*#__PURE__*/_jsx("div", {
      "data-testid": "direct-advertisement",
      id: id,
      ref: setAdDivElement,
      children: /*#__PURE__*/_jsx("div", {
        id: config.code,
        "data-testid": "direct-advertisement-node"
      })
    })]
  });
};

export default DirectAdvertisement;